/* eslint-disable @typescript-eslint/no-explicit-any */
// formContext.tsx
import { useGetApi } from "@src/api/useApi";
import { EAdmissionStages } from "@src/constants/modals/admissions";
import { useAdmissionStageApiHook } from "@src/hooks/AdmissionStages/getAdmissionStagesApi";
import { useSubscribe } from "@src/hooks/useSubscribe";
import { useAdmissionStagesStore } from "@src/store/AdmissionStagesStore";
import { useUserStore } from "@src/store/UserStore";
import { createContext, useContext, useEffect, useState } from "react";


type FormStepContextType = {

  getApplicationNumber: () => any;
  getSelectedProgramId: () => number | null;
  setApplicationNumber: (applicationId: any) => void;
  setSelectedProgramId: (programId: number) => void;

};

export const FormStepContext = createContext<FormStepContextType | null>(null);

export const useFormStepContext = () => {
  const ctx = useContext(FormStepContext);
  if (!ctx) throw new Error("FormStepContext not found");
  return ctx;
};

export const FormStepProvider = ({ children }: { children: React.ReactNode }) => {

  const [applicationId, setApplicationId] = useState<string | null>(null);
  const [selectedProgramId, setSelectedProgramId] = useState<number | null>(null);


  const setRawAdmissionStages = useAdmissionStagesStore((s) => s.setRawAdmissionStages);
  const setCurrentApplicationData = useAdmissionStagesStore((s)=>s.setCurrentApplicationData);
  const currentApplicationData = useAdmissionStagesStore((s) => s.currentApplicationData);
  const setTotalWorkExperience = useAdmissionStagesStore((s) => s.setTotalWorkExperience);
  const setCategory = useAdmissionStagesStore((s) => s.setCategory);
  const userLoggedIn = useUserStore((s) => s.user);

  const basicDetailsUserId = currentApplicationData?.userId || userLoggedIn?.id;

  const { data: basicDetails } = useAdmissionStageApiHook({
    key: EAdmissionStages.basic_details,
    params: {
      section: EAdmissionStages.basic_details,
      userId: String(basicDetailsUserId),
    },
    enabled: !!basicDetailsUserId,
  });

  useEffect(() => {
    if (!basicDetails?.data) return;
    setTotalWorkExperience(basicDetails.data?.personal_details?.totalWorkExperience ?? null);
    setCategory(basicDetails.data?.personal_details?.category ?? null);
  }, [basicDetails]);


  useEffect(() => {
    refetch();
    // refetchCurrentApplication();
  }, [applicationId])



  useSubscribe('refetchAdmissionStatus', () => {
    refetch();
    refetchCurrentApplication();
  });

  useSubscribe('refetchCurrentApplication',()=>{
    refetchCurrentApplication();
  })



  const setApplicationNumber = (applicationId: string | null) => {
    setApplicationId(applicationId);
  };
  const getApplicationNumber = () => {
    return applicationId ? applicationId : null;
  };



  const getSelectedProgramId = () => {
    return selectedProgramId ? selectedProgramId : null;
  };
  const { data: admissionStagesResponse, refetch } = useGetApi({
    key: ['admission-status', getApplicationNumber()], url: getApplicationNumber()
      ? `/progress/status/${getApplicationNumber()}`
      : `/progress/status`
  });

   const { data: getUsersApplications, refetch: refetchCurrentApplication } = useGetApi({ key: 'application-tracking', url: `/application/getApplications?applicationNumber=${getApplicationNumber()}`, enabled: !!getApplicationNumber() });

   setCurrentApplicationData(getUsersApplications?.data?.applications?.[0]);

  useEffect(() => {
    if (admissionStagesResponse) {
      setRawAdmissionStages(admissionStagesResponse);
    }
  }, [admissionStagesResponse]);
  return (
    <FormStepContext.Provider value={{ setApplicationNumber, getApplicationNumber, getSelectedProgramId, setSelectedProgramId }}>
      {children}
    </FormStepContext.Provider>
  );
};





// const LazyWithRef = (importFunc: () => Promise<{ default: React.ComponentType<any> }>) =>
//   React.lazy(() =>
//     importFunc().then((module) => ({
//       default: React.forwardRef((props, ref) => {
//         const Component = module.default;
//         return <Component {...props} ref={ref} />;
//       }),
//     }))
//   );
// type ComponentWithRefProps<P> = React.ComponentType<P & { ref?: ForwardedRef<StepRefHandle> }>;
// const renderStage = <P,>(
//   Component: ComponentWithRefProps<P>,
//   ref: ForwardedRef<StepRefHandle> | null,
//   extraProps?: P
// ): ReactElement => {
//   return React.createElement(Component, {
//     ...(extraProps as P),
//     ref: ref ?? undefined,
//   });
// };